// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePdfFilledSvg from "@fishx/icons-svg/es/asn/FilePdfFilled";
import FishxIcon from '../components/FishxIcon';

var FilePdfFilled = function FilePdfFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfFilledSvg
  }));
};

FilePdfFilled.displayName = 'FilePdfFilled';
export default React.forwardRef(FilePdfFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FilePdfFilled.js
// module id = 2730
// module chunks = 0